<template>
<div>
  <div class="numul">
    <ul>
      <li class="blue">{{drawList[0]}}</li>
      <li class="add">+</li>
      <li class="blue">{{drawList[1]}}</li>
      <li class="add">+</li>
      <li class="blue">{{drawList[2]}}</li>
      <li class="add">=</li>
      <li class="red">{{drawList[0]*1+drawList[1]*1+drawList[2]*1}}</li>
    </ul>
  </div>
  <div class="smalltable" v-if="types=='home'">
    <table cellpadding="0" cellspacing="0" border="0" style="width:100%;textAlign:center;border-top: solid 1px #e5e5e5;border-left: solid 1px #e5e5e5;">
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30" colspan="3">总和</td>
      </tr>
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;" width="140" height="30" v-for="(item,index) in drawingNumbertool" :key="index">{{item}}</td>
      </tr>
    </table>
  </div>
</div>
</template>

<script>
import lotteryRandBall from "~/mixins/lotteryRandBall.mixins";
export default {
  mixins: [lotteryRandBall],
  computed: {
    drawingNumbertool(){
      let tool = [];
      let { drawingNumber } = this;
      if(drawingNumber.length<=1){
        drawingNumber = this.randList;
      }
      let add = drawingNumber.reduce((a,b) => a * 1 + b * 1);
      tool.push(add);
      if (add > 13) { tool.push("大") } else { tool.push("小") };
      if (add %2 == 0) { tool.push("双") } else { tool.push("单") };
      return tool
    }
  }
};
</script>

<style lang="less" scoped>
.numul {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 16px;
  ul {
    display: flex;
    height: 56px;
    .blue {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      background: url(../../assets/xuebitu.png) no-repeat -1px -47px !important;
    }
    .red {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      background: url(../../assets/xuebitu.png) no-repeat -91px -49px !important;
    }
    .add {
      width: 36px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 36px;
      font-weight: 300;
    }
  }
}
</style>